import { Form } from './Form';
export default Form;
